<div class="input-wrapper" xmlns="http://www.w3.org/1999/html">
  <div class="suffix" *ngIf="icon">
    <ui-icon [nameIcon]="icon"></ui-icon>
  </div>
  <!--[ngClass]="{'ng-dirty': password.dirty, 'ng-invalid': password.invalid}"-->
  <input *ngIf="!isTextarea"
    autocomplete="off"
    [formControl]="formControl"
    [type]="type"
    nz-input
    [placeholder]="placeholder"
  />
  <textarea *ngIf="isTextarea"
    autocomplete="off"
    [formControl]="formControl"
    nz-input
    [rows]="rows"
    [placeholder]="placeholder"
  ></textarea>
</div>
<ng-container *ngIf="formControl.errors && formControl.touched">
  <div class="errors" *ngIf="formControl.errors.required">
    <div class="error">Обязательное поле</div>
  </div>
  <!--<div *ngIf="name.errors?.['minlength']">
              This field must have at least 1 character.
            </div>
            <div *ngIf="name.errors?.['maxlength']">
              This field must have at most 250 characters.
            </div>-->
</ng-container>

